import React, { Component } from 'react'
import has from 'lodash/has'

import '../../../css/striped-fields.css'

class MerchantSettingsFieldsPaypal extends Component {

    handleKeyPress(event) {
        if (event.key === 'Enter') {
            this.props.handleFieldSave(event.target.id)
        }
    }

    handleChange(event){
        event.preventDefault()
        this.props.handleMerchantInputUpdate(event)
    }

    showButton(id){
        return <button
            className={'icon-pencil save-item-btn' +
                (this.props.initialMerchantValues[id] !== this.props.merchant[id] ? ' show-edit-button' : '') +
                (this.props.fieldsSaving.indexOf(id) > -1 ? ' loading' : '') +
                (!!this.props.fieldsSuccess.id ? ' icon-checkmark' : '')
            }
            onClick={() => this.props.handleFieldSave(id)}
            disabled={this.props.fieldsSaving.indexOf(id) > -1}
        ></button>
    }

    showStatus(id){
        let items = []
        
        // Show error
        has(this.props.fieldsErrored, id) &&
            items.push(<div key={'error-' + id} className="error msg_animate">{this.props.fieldsErrored[id]}</div>)

        // Show success
        has(this.props.fieldsSuccess, id) &&
            items.push(<div key={'success-' + id} className="success msg_animate">{this.props.fieldsSuccess[id]}</div>)

        return items
    }

    getMerchantPassword(id){
        let value = this.props.initialMerchantValues[id] ? `••••••••••••••••` : ''
        if (this.props.merchant[id] !== true && this.props.merchant[id] !== false) {
            value = this.props.merchant[id]
        }

        return value
    }

    render() {
        const { merchant } = this.props

        return (
            <div>
                <div className="paypal-fields">
                    <div className="fieldset">
                        <label className="title-label">Sandbox Information:</label>

                        <table className="product-prices product-prices--fixed-column">
                            <tbody>
                                <tr className="product-item">
                                    <td className="item-title">User</td>
                                    <td>
                                        {this.showStatus('merchant_user_sandbox')}
                                        <input type="text" id="merchant_user_sandbox" value={merchant.merchant_user_sandbox} placeholder="user.email.com" maxLength="100"
                                            onKeyPress={e => this.handleKeyPress(e)}
                                            onChange={e => this.handleChange(e)}
                                        />
                                    </td>
                                    <td className="save-cell">
                                        {this.showButton('merchant_user_sandbox')}
                                    </td>
                                </tr>
                                <tr className="product-item">
                                    <td className="item-title">Signature</td>
                                    <td>
                                        {this.showStatus('merchant_signature_sandbox')}
                                        <input type="text" id="merchant_signature_sandbox" value={merchant.merchant_signature_sandbox} placeholder="1234567890-1234567890" maxLength="100"
                                            onKeyPress={e => this.handleKeyPress(e)}
                                            onChange={e => this.handleChange(e)}
                                        />
                                    </td>
                                    <td className="save-cell">
                                        {this.showButton('merchant_signature_sandbox')}
                                    </td>
                                </tr>
                                <tr className="product-item">
                                    <td className="item-title">Password</td>
                                    <td>
                                        {this.showStatus('merchant_password_sandbox')}
                                        <input type="password" id="merchant_password_sandbox" value={this.getMerchantPassword('merchant_password_sandbox')} maxLength="100"
                                            onKeyPress={e => this.handleKeyPress(e)}
                                            onChange={e => this.handleChange(e)}
                                        />
                                    </td>
                                    <td className="save-cell">
                                        {this.showButton('merchant_password_sandbox')}
                                    </td>
                                </tr>
                                <tr className="product-item">
                                    <td className="item-title">Credit Card Type</td>
                                    <td>
                                        {this.showStatus('sandbox_card_type')}
                                        <input type="text" id="sandbox_card_type" value={merchant.sandbox_card_type} placeholder="Visa/Mastercard/etc" maxLength="30"
                                            onKeyPress={e => this.handleKeyPress(e)}
                                            onChange={e => this.handleChange(e)}
                                        />
                                    </td>
                                    <td className="save-cell">
                                        {this.showButton('sandbox_card_type')}
                                    </td>
                                </tr>
                                <tr className="product-item">
                                    <td className="item-title">Credit Card Acct</td>
                                    <td>
                                        {this.showStatus('sandbox_card_acct')}
                                        <input type="text" id="sandbox_card_acct" value={merchant.sandbox_card_acct} placeholder="1234123412341234" maxLength="16"
                                            onKeyPress={e => this.handleKeyPress(e)}
                                            onChange={e => this.handleChange(e)}
                                        />
                                    </td>
                                    <td className="save-cell">
                                        {this.showButton('sandbox_card_acct')}
                                    </td>
                                </tr>
                                <tr className="product-item">
                                    <td className="item-title">Credit Card Expiry</td>
                                    <td>
                                        {this.showStatus('sandbox_card_expiry')}
                                        <input className="date" type="text" id="sandbox_card_expiry" value={merchant.sandbox_card_expiry} placeholder="201603" maxLength="10"
                                            onKeyPress={e => this.handleKeyPress(e)}
                                            onChange={e => this.handleChange(e)}
                                        />
                                    </td>
                                    <td className="save-cell">
                                        {this.showButton('sandbox_card_expiry')}
                                    </td>
                                </tr>
                                <tr className="product-item">
                                    <td className="item-title">Credit Card Expiry</td>
                                    <td>
                                        {this.showStatus('sandbox_card_cvv')}
                                        <input className="date" type="text" id="sandbox_card_cvv" value={merchant.sandbox_card_cvv} placeholder="123" maxLength="4"
                                            onKeyPress={e => this.handleKeyPress(e)}
                                            onChange={e => this.handleChange(e)}
                                        />
                                    </td>
                                    <td className="save-cell">
                                        {this.showButton('sandbox_card_cvv')}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <div className="fieldset">
                        <label className="title-label">Live Information:</label>

                        <table className="product-prices product-prices--fixed-column">
                            <tbody>
                                <tr className="product-item">
                                    <td className="item-title">User</td>
                                    <td>
                                        {this.showStatus('merchant_user_live')}
                                        <input type="text" id="merchant_user_live" value={merchant.merchant_user_live} placeholder="user.email.com" maxLength="100"
                                            onKeyPress={e => this.handleKeyPress(e)}
                                            onChange={e => this.handleChange(e)}
                                        />
                                    </td>
                                    <td className="save-cell">
                                        {this.showButton('merchant_user_live')}
                                    </td>
                                </tr>
                                <tr className="product-item">
                                    <td className="item-title">Signature</td>
                                    <td>
                                        {this.showStatus('merchant_signature_live')}
                                        <input type="text" id="merchant_signature_live" value={merchant.merchant_signature_live} placeholder="1234567890-1234567890" maxLength="100"
                                            onKeyPress={e => this.handleKeyPress(e)}
                                            onChange={e => this.handleChange(e)}
                                        />
                                    </td>
                                    <td className="save-cell">
                                        {this.showButton('merchant_signature_live')}
                                    </td>
                                </tr>
                                <tr className="product-item">
                                    <td className="item-title">Password</td>
                                    <td>
                                        {this.showStatus('merchant_password_live')}
                                        <input type="password" id="merchant_password_live" value={this.getMerchantPassword('merchant_password_live')} maxLength="100"
                                            onKeyPress={e => this.handleKeyPress(e)}
                                            onChange={e => this.handleChange(e)}
                                        />
                                    </td>
                                    <td className="save-cell">
                                        {this.showButton('merchant_password_live')}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        )
    }
}

export default MerchantSettingsFieldsPaypal



// WEBPACK FOOTER //
// ./src/components/admin/merchant/MerchantSettingsFieldsPaypal.js